import { ChangeEvent, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { ColumnDescription } from "react-bootstrap-table-next";
import moment from "moment";
import "moment/locale/pt-br";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCalendarDay,
    faCogs,
    faComment,
    faEnvelope,
    faFilter,
    faPlus,
    faStreetView,
    faSync,
    faUser,
} from "@fortawesome/free-solid-svg-icons";

import Table from "../../Table";

import { HistoricoInterface } from "../../../Interfaces/Geral/Historicos/HistoricoInterface";
import {
    CadastrarHistoricosController,
    ListarHistoricosController,
} from "../../../Controllers/Cobranca/GestaoAtendimento/HistoricosControllers";

//Hooks
import { useUserInfor } from "../../../Context/User";
import "./styles.css";
import { Switch } from "../Forms/Switch";

export interface ModalHistoricosProps {
    ID_CASO: number;
    ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO?: number;
    ID_ETAPA_TIPO_CASO?: number;
}
interface NovoHistoricoFormInterface {
    DS_HISTORICO: string;
}
interface FiltrosFormInterface {
    FL_ATENDIMENTO_SINC_UAU: boolean;
    FL_CLIENTE_VISUALIZA_HISTORICO: boolean;
    FL_ORIGEM_CHAT: boolean;
    FL_ORIGEM_EMAIL: boolean;
    FL_SISTEMA_USUARIO: boolean;
}

export default function HistoricoCardPage(props: ModalHistoricosProps) {
    const [lstHistoricosFiltered, setLstHistoricosFiltered] = useState<
        Array<HistoricoInterface>
    >([]);
    const [loading, setLoading] = useState(false);
    const novoHistoricoForm = useForm();
    const filtrosForm = useForm();

    const [lstHistoricos, setLstHistoricos] = useState<
        Array<HistoricoInterface>
    >([]);

    const { UserInfor } = useUserInfor();

    const [Selecionado, setSelecionado] = useState(false);

    useEffect(() => {
        updateHistorico(props.ID_CASO);
    }, [props.ID_CASO]);

    useEffect(() => {
        let lstHistoricoSemStyleOutlookMobile = lstHistoricos.map((x) => {
            if(x.DS_HISTORICO.includes("ms-outlook-mobile-signature") === true)
                x.DS_HISTORICO = removeMsOutlookMobileSignature(x.DS_HISTORICO);
            
            return x;
        });
        setLstHistoricosFiltered(lstHistoricoSemStyleOutlookMobile);
    }, [lstHistoricos]);

    const removeMsOutlookMobileSignature = (html : string) => {
        return html.replace(/<style.*?<\/style>/gis,'');
    }
    function updateHistorico(ID_CASO: number) {
        setLoading(true);
        ListarHistoricosController(ID_CASO).then((response) => {
            setLstHistoricos(response);
            setLoading(false);
        });
    }

    function handleChange(e: ChangeEvent<HTMLInputElement>) {
        setSelecionado(e.target.checked);
    }

    function handleFiltrosFormSubmit(formData: FiltrosFormInterface) {
        setLstHistoricosFiltered(
            lstHistoricos.filter(
                (historico) =>
                    (!formData.FL_SISTEMA_USUARIO ||
                        !historico.FL_SISTEMA_USUARIO) &&
                    (!formData.FL_ORIGEM_EMAIL || historico.FL_ORIGEM_EMAIL) &&
                    (!formData.FL_ORIGEM_CHAT || historico.FL_ORIGEM_CHAT) &&
                    (!formData.FL_ATENDIMENTO_SINC_UAU ||
                        historico.FL_ATENDIMENTO_SINC_UAU) &&
                    (!formData.FL_CLIENTE_VISUALIZA_HISTORICO ||
                        historico.FL_CLIENTE_VISUALIZA_HISTORICO)
            )
        );
    }

    function handleNovoHistoricoFormSubmit({
        DS_HISTORICO,
    }: NovoHistoricoFormInterface) {
        if (UserInfor.ID_USUARIO) {
            CadastrarHistoricosController({
                DS_HISTORICO: DS_HISTORICO,
                DT_CADASTRO: new Date().toISOString(),
                ID_CASO: props.ID_CASO,
                ID_USUARIO: UserInfor.ID_USUARIO,
                ID_CASO_HISTORICO: 0,
                ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO:
                    props.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO || 0,
                ID_ETAPA_TIPO_CASO: props.ID_ETAPA_TIPO_CASO || 0,
                FL_CLIENTE_VISUALIZA_HISTORICO: Selecionado,
            }).then(() => {
                updateHistorico(props.ID_CASO);
                novoHistoricoForm.reset();
                filtrosForm.reset();
            });
        }
    }

    //Tabela
    const formatter = (cell: any, row: HistoricoInterface) => {
        return (
            <div className="d-flex align-itens-center flex-column py-3 px-2">
                <header className="d-flex align-itens-center justify-content-between flex-wrap">
                    <div>
                        <FontAwesomeIcon
                            icon={faCalendarDay}
                            className="mr-2"
                        />
                        {moment(row.DT_CADASTRO.toString()).format("lll")}
                    </div>
                    <div className="flags">
                        {row.FL_SISTEMA_USUARIO ? (
                            <span className="label abel-pill label-inline label-success">
                                <FontAwesomeIcon
                                    icon={faCogs}
                                    className="mr-2"
                                />{" "}
                                Sistema
                            </span>
                        ) : (
                            <div>
                                <span className="label abel-pill label-inline label-success">
                                    <FontAwesomeIcon
                                        icon={faUser}
                                        className="mr-2"
                                    />{" "}
                                    Usuário: {row.DS_USUARIO}
                                </span>
                            </div>
                        )}

                        {row.FL_ORIGEM_EMAIL && (
                            <span className="label abel-pill label-inline label-success">
                                <FontAwesomeIcon
                                    icon={faEnvelope}
                                    className="mr-2"
                                />{" "}
                                Email
                            </span>
                        )}

                        {row.FL_ORIGEM_CHAT && (
                            <span className="label abel-pill label-inline label-success">
                                <FontAwesomeIcon
                                    icon={faComment}
                                    className="mr-2"
                                />{" "}
                                Chat
                            </span>
                        )}

                        {row.FL_ATENDIMENTO_SINC_UAU && (
                            <span className="label abel-pill label-inline label-success">
                                <FontAwesomeIcon
                                    icon={faSync}
                                    className="mr-2"
                                />{" "}
                                Sincronizado com UAU
                            </span>
                        )}

                        {row.FL_CLIENTE_VISUALIZA_HISTORICO && (
                            <span className="label abel-pill label-inline label-success">
                                <FontAwesomeIcon
                                    icon={faStreetView}
                                    className="mr-2"
                                />{" "}
                                Cliente Visualiza
                            </span>
                        )}
                    </div>
                </header>
                <div
                    className="ds-historico"
                    dangerouslySetInnerHTML={{ __html: row.DS_HISTORICO }}
                />
            </div>
        );
    };

    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_HISTORICO",
            text: "Históricos",
            formatter,
        },
    ];

    return (
        <div>
            <div className="col-12 collapse mb-5" id="collapseForm">
                <h5 className="text-center">Cadastre Histórico</h5>
                {
                    <form
                        className="row"
                        onSubmit={novoHistoricoForm.handleSubmit(
                            handleNovoHistoricoFormSubmit
                        )}
                    >
                        <div className="col-12 col-md-10">
                            <textarea
                                name="DS_HISTORICO"
                                className={`form-control placeholder-dark-45 h-100`}
                                placeholder="Descrição"
                                ref={novoHistoricoForm.register({
                                    required: "Insira a descrição do histórico",
                                })}
                            />
                        </div>
                        <div className="mt-2 ml-2 mb-1">
                            <Switch
                                label="Cliente visualiza"
                                type="checkbox"
                                color="success"
                                swicthSize="sm"
                                checked={Selecionado}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-12 col-md-12 mt-3 mr-2 justify-content-center">
                            <button className="col-12 h-100 btn btn-outline-success font-weight-bold d-flex align-items-center justify-content-center">
                                <FontAwesomeIcon
                                    icon={faPlus}
                                    size="lg"
                                    className="mr-1"
                                />{" "}
                                Cadastrar
                            </button>
                        </div>
                    </form>
                }
            </div>

            <form
                className="form-group row"
                onSubmit={filtrosForm.handleSubmit(handleFiltrosFormSubmit)}
            >
                <div className="col-12 col-lg-10 filters">
                    <div className="d-flex align-items-center">
                        <span
                            className="mr-2 switch switch-outline switch-sm switch-icon switch-info"
                            data-toggle="tooltip"
                        >
                            <label>
                                <input
                                    id="FL_SISTEMA_USUARIO_STATUS"
                                    name="FL_SISTEMA_USUARIO"
                                    type="checkbox"
                                    ref={filtrosForm.register()}
                                />
                                <span></span>
                            </label>
                        </span>
                        <label htmlFor="FL_SISTEMA_USUARIO_STATUS">
                            Interação com Usuário
                        </label>
                    </div>
                    <div className="d-flex align-items-center">
                        <span
                            className="mr-2 switch switch-outline switch-sm switch-icon switch-info"
                            data-toggle="tooltip"
                        >
                            <label>
                                <input
                                    id="FL_ORIGEM_EMAIL_STATUS"
                                    name="FL_ORIGEM_EMAIL"
                                    type="checkbox"
                                    ref={filtrosForm.register()}
                                />
                                <span></span>
                            </label>
                        </span>
                        <label htmlFor="FL_ORIGEM_EMAIL_STATUS">
                            Origem em Email
                        </label>
                    </div>
                    <div className="d-flex align-items-center">
                        <span
                            className="mr-2 switch switch-outline switch-sm switch-icon switch-info"
                            data-toggle="tooltip"
                        >
                            <label>
                                <input
                                    id="FL_ORIGEM_CHAT_STATUS"
                                    name="FL_ORIGEM_CHAT"
                                    type="checkbox"
                                    ref={filtrosForm.register()}
                                />
                                <span></span>
                            </label>
                        </span>
                        <label htmlFor="FL_ORIGEM_CHAT_STATUS">
                            Origem em Chat
                        </label>
                    </div>
                    <div className="d-flex align-items-center">
                        <span
                            className="mr-2 switch switch-outline switch-sm switch-icon switch-info"
                            data-toggle="tooltip"
                        >
                            <label>
                                <input
                                    id="FL_ATENDIMENTO_SINC_UAU_STATUS"
                                    name="FL_ATENDIMENTO_SINC_UAU"
                                    type="checkbox"
                                    ref={filtrosForm.register()}
                                />
                                <span></span>
                            </label>
                        </span>
                        <label htmlFor="FL_ATENDIMENTO_SINC_UAU_STATUS">
                            Integração UAU
                        </label>
                    </div>
                    <div className="d-flex align-items-center">
                        <span
                            className="mr-2 switch switch-outline switch-sm switch-icon switch-info"
                            data-toggle="tooltip"
                        >
                            <label>
                                <input
                                    id="FL_CLIENTE_VISUALIZA_HISTORICO_STATUS"
                                    name="FL_CLIENTE_VISUALIZA_HISTORICO"
                                    type="checkbox"
                                    ref={filtrosForm.register()}
                                />
                                <span></span>
                            </label>
                        </span>
                        <label htmlFor="FL_CLIENTE_VISUALIZA_HISTORICO_STATUS">
                            Cliente Visualiza
                        </label>
                    </div>
                </div>

                <div className="col-12 col-lg-2 mt-lg-0 mt-2 d-flex align-items-end justify-content-between">
                    <div className="col-12 d-flex align-items-end justify-content-start">
                        <button
                            type="submit"
                            className="btn btn-block btn-outline-dark"
                        >
                            <FontAwesomeIcon icon={faFilter} className="mr-2" />
                            Filtrar
                        </button>
                    </div>
                </div>
            </form>
            <Table
                columns={columns}
                data={lstHistoricosFiltered}
                keyField="ID_CASO_HISTORICO"
                loading={loading}
                bordered={false}
            />
        </div>
    );
}
